import React, { useState } from "react";
import Base from "./Employee_Base";
import {
  Breadcrumbs,
  Link,
  CircularProgress,
  IconButton,
  InputAdornment,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import useAxios from "../Auth/UseAxios";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import { useAuth } from "../Auth/AuthContext";

export const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // 👁️ Password visibility states
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const api = useAxios();
  const { logout } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Basic validations
    if (!oldPassword || !newPassword || !confirmPassword) {
      Swal.fire("Error", "All fields are required.", "error");
      setLoading(false);
      return;
    }

    if (oldPassword === newPassword) {
      Swal.fire("Error", "New password cannot be the same as old password.", "error");
      setLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "New password and confirm password do not match.", "error");
      setLoading(false);
      return;
    }

    try {
      const response = await api.post(
        `${EMPLOYEE_API_BASE_URL}/employee/change-password`,
        { oldPassword, newPassword, confirmPassword },
        { headers: { "Content-Type": "application/json" } }
      );

      Swal.fire({
        title: "Success",
        text: response.data?.message || "Password changed successfully! Please log in again.",
        icon: "success",
      }).then(() => {
        logout();
      });

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Error changing password:", error);

      let message = "Something went wrong. Please try again later.";

      if (error.response && error.response.data) {
        const { message: backendMessage, error: backendError } = error.response.data;
        if (backendMessage) message = backendMessage;
        else if (backendError) message = backendError;
        else if (error.response.status === 401) message = "Old password is incorrect.";
        else if (error.response.status === 409) message = "Passwords do not match.";
      }

      Swal.fire("Error", message, "error");
    } finally {
      setLoading(false);
    }
  };

  // 👁️ Toggle password visibility
  const renderPasswordField = (label, value, onChange, show, setShow, id) => (
    <div className="row pb-3">
      <div
        className="col-sm-3"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <label htmlFor={id} className="col-sm-6 col-form-label fw-bold">
          {label}*
        </label>
      </div>
      <div className="col-sm-8 position-relative">
        <input
          type={show ? "text" : "password"}
          id={id}
          value={value}
          className="form-control"
          onChange={(e) => onChange(e.target.value)}
          required
        />
        <InputAdornment position="end" style={{ position: "absolute", right: 5, top: 5 }}>
          <IconButton onClick={() => setShow(!show)} edge="end">
            {show ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      </div>
    </div>
  );

  return (
    <Base>
      {/* Breadcrumb */}
      <div
        className="pt-3 mt-5"
        style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            key="1"
            color="inherit"
            href="/employee/dashboard"
            sx={{ color: "blue", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="hover"
            key="2"
            color="inherit"
            href="/employee/change_password"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Change Password
          </Link>
        </Breadcrumbs>
      </div>

      {/* Form */}
      <div className="pt-">
        <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>
          Change Password
        </h2>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <hr style={{ width: "90%" }} />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ padding: "0 20px " }}>
            {renderPasswordField("Old Password", oldPassword, setOldPassword, showOld, setShowOld, "oldPassword")}
            {renderPasswordField("New Password", newPassword, setNewPassword, showNew, setShowNew, "newPassword")}
            {renderPasswordField("Confirm Password", confirmPassword, setConfirmPassword, showConfirm, setShowConfirm, "confirmPassword")}
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "darkslategray",
                color: "white",
                border: "none",
                padding: "8px 15px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </Base>
  );
};
